<div class="page-layout--wide">
  <div class="page-layout-content">
    <h1>Subscribe</h1>
    <ng-container *ngrxLet="deviceIsSmall$; let isSmall">
      <spt-payment-wizard *ngIf="!isSmall"></spt-payment-wizard>
      <spt-payment-wizard-small *ngIf="isSmall"></spt-payment-wizard-small>
    </ng-container>
  </div>
</div>
